const truncateString = (str: string): string => {
  if (str && str.length > 30) {
    return `${str.slice(0, 30)}...`;
  }
  return str;
};

export default truncateString;
